import { API_BASE_URL } from "../urls.api";

export const ALARM_RULES_URL = `${API_BASE_URL}/alarm-rules`;

export const getAlarmRuleUrl = (id: string) => `${ALARM_RULES_URL}/${id}`;

export const ALARM_RULES_REORDER_URL = `${ALARM_RULES_URL}/reorder`;
